import { memo } from 'react';
import { Close } from '@mui/icons-material';
import clsx from 'clsx';

type Props = {
  label: string;
  onRemove: () => void;
  className?: string;
  isDisabled?: boolean;
};

export const Chip = memo(({ label, onRemove, className, isDisabled }: Props) => (
  <div className={clsx('flex items-center whitespace-nowrap space-x-2 bg-white border rounded-full px-4 py-2', className)}>
    <span className="text-sm text-gray-800">{label}</span>
    {!isDisabled && (
      <div onClick={onRemove} className="text-gray-500 cursor-pointer hover:text-gray-700 focus:outline-none">
        <Close />
      </div>
    )}
  </div>
));
